<template>
  <div
    class="w-full"
  >
    <ContractNavbar
      :companies="companies"
      :company-ids.sync="companyIds"
      :contract-name.sync="contractName"
      :contract-type.sync="contractType"
      :contract-updated="contractUpdated"
      :contract-active.sync="contractActive"
      @save="saveContract"
      @preview="previewPdf"
    />
    <div class="content flex">
      <div
        class="left-side"
        :class="[!sidenav ? 'col-md-11' : 'col-md-9', !opened ? 'col-md-12' : '']"
      >
        <draggable
          :list="sections"
          group="sections"
          @start="drag=true"
          @end="dragEnd"
        >
          <span
            v-for="section in sections"
            :key="section.order"
            class="container-fluid mt-3 flex"
            :class="{hidden : !section.editor_display }"
            @dragover="dragOver($event)"
            @drop="dragDrop(section.uid, $event)"
            @dragleave="dragLeave($event)"
          >
            <div class="contract-section col-md-12">
              <span v-if="!section.components.length">
                <span v-if="!dragging || drag" class="flex justify-content-center h-full align-items-center">
                  Drag a section here
                </span>
              </span>
              <span class="h-full" v-else>
                <span>
                  <span>
                    <div class="row flex h-full justify-content-center flex-center">
                      <div v-for="component in section.components" :key="component.uid" class="h-full" :class="component.class">

                        <text-editor
                          v-if="!component.class.includes('noEditor')"
                          :section-id="section.uid"
                          :component-id="component.uid"
                          :component="component"
                          :contract-updated="contractUpdated"
                          :sect="sections"
                          :variables-array="variablesArray"
                          :variables-keys="variablesKeys"
                          :drag="drag"
                          :dragging="dragging"
                          @deleted="deleteColumn(section.uid, component.uid)"
                          @update="storeHtmlToObject"
                        />
                      </div>
                    </div>
                  </span>
                </span>
              </span>
            </div>
            <span class="flex flex-column justify-content-start pl-2">

              <i class="fa fa-arrows pointer pb-3" />
              <i class="fa fa-floppy-o pointer delete-section-ico pb-3" />
              <i class="fa fa-eye pb-3 pointer delete-section-ico" data-toggle="dropdown" />
              <div class="dropdown-menu p-3" aria-labelledby="showComponentButton">
                <form>
                  <span class="font-weight-bold">Show section to</span>
                  <div class="switchToggle flex justify-content-between pb-2 pt-4">
                    <span>Customer</span>
                    <input type="checkbox" :id="'customer' + section.uid" v-model="section.customer_display" value="true" />
                    <label :for="'customer' + section.uid">Toggle</label>
                  </div>
                  <div class="switchToggle flex justify-content-between">
                    <span>Foreman</span>
                    <input type="checkbox" :id="'foreman' + section.uid" v-model="section.mover_display" value="true" />
                    <label :for="'foreman' + section.uid">Toggle</label>
                  </div>
                </form>
              </div>
              <i @click="deleteContainer(section.id)" class="fa fa-trash pointer delete-section-ico pb-3" />
            </span>
          </span>
        </draggable>
        <div class="new-section mt-2 flex justify-content-center align-items-center mb-4 pointer" @click="createSection">
          <span class="new-section-btn"> <i class="fa fa-plus-circle" /> Add new section</span>
        </div>
      </div>

      <div class="right-side col-md-3 fixed" v-if="sidenav && opened">
        <span
          class="flex justify-content-start pointer pt-3"
          @click="showSidebar"
        >
          <i class="fa fa-chevron-right chevron" />
          <span class="font-weight-bold">
            Collapse
          </span>
        </span>
        <div class="container-fluid mt-3">
          <h5>Select from predefined sections</h5>
          <div class="row pt-3">
            <div class="col-md-4">
              <div class="box" draggable="true" @dragstart="dragStart(1, $event)">
                <div class="box-1 flex justify-content-center pointer">
                  <div class="box-column w-full" />
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="box" draggable="true" @dragstart="dragStart(2, $event)">
                <div class="box-2 flex justify-content-center pointer">
                  <div class="mr-1 box-column w-full" />
                  <div class="box-column w-full" />
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="box" draggable="true" @dragstart="dragStart(3, $event)">
                <div class="box-3 flex justify-content-center pointer">
                  <div class="mr-1 box-column w-full" />
                  <div class="mr-1 box-column  w-full" />
                  <div class="box-column w-full" />
                </div>
              </div>
            </div>

            <div class="col-md-4 mt-3">
              <div class="box" draggable="true" @dragstart="dragStart(4, $event)">
                <div class="box-3 flex justify-content-center pointer">
                  <div class="mr-1 box-column" style="width: 66%" />
                  <div class="box-column" style="width: 33%" />
                </div>
              </div>
            </div>
            <div class="col-md-4 mt-3">
              <div class="box" draggable="true" @dragstart="dragStart(5, $event)">
                <div class="box-3 flex justify-content-center pointer">
                  <div class="mr-1 box-column" style="width: 33%" />
                  <div class="box-column" style="width: 66%" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-side col-md-1" v-if="!sidenav && opened">
        <span
          class="flex justify-content-start pointer pt-3"
          @click="showSidebar"
        >
          <i class="fa fa-chevron-left chevron" />
          <span class="font-weight-bold">
            Expand
          </span>
        </span>
        <div class="container-fluid mt-3">
          <div class="row pt-3">
            <div class="col">
              <div class="box mb-3" draggable="true" @dragstart="dragStart(1, $event)">
                <div class="box-1 flex justify-content-center pointer">
                  <div class="box-column w-full" />
                </div>
              </div>
              <div class="box mb-3" draggable="true" @dragstart="dragStart(2, $event)">
                <div class="box-2 flex justify-content-center pointer">
                  <div class="mr-1 box-column w-full" />
                  <div class="box-column w-full" />
                </div>
              </div>
              <div class="box mb-3" draggable="true" @dragstart="dragStart(3, $event)">
                <div class="box-3 flex justify-content-center pointer">
                  <div class="mr-1 box-column w-full" />
                  <div class="mr-1 box-column  w-full" />
                  <div class="box-column w-full" />
                </div>
              </div>
              <div class="box mb-3" draggable="true" @dragstart="dragStart(4, $event)">
                <div class="box-3 flex justify-content-center pointer">
                  <div class="mr-1 box-column" style="width: 66%" />
                  <div class="box-column" style="width: 33%" />
                </div>
              </div>
              <div class="box mb-3" draggable="true" @dragstart="dragStart(5, $event)">
                <div class="box-3 flex justify-content-center pointer">
                  <div class="mr-1 box-column" style="width: 33%" />
                  <div class="box-column" style="width: 66%" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import { mapState } from 'vuex';
import _ from 'lodash';
import draggable from 'vuedraggable';
import TextEditor from './TextEditor';
import Errors from '../../classes/Errors';
import ContractNavbar from './ContractNavbar';

export default {
  name: 'ContractEdit',
  components: {
    TextEditor,
    ContractNavbar,
    draggable,
  },
  data: () => ({
    errors: new Errors(),
    dragging: false,
    sidenav: false,
    opened: true,
    pdf: '',
    draggingElement: null,
    focused: false,
    contractName: '',
    contractActive: 1,
    sections: [],
    companyIds: [],
    html: '',
    drag: false,
    contractUpdated: '',
    variablesArray: [],
    variablesKeys: [],
    contractType: {},
  }),
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
    }),
  },
  created() {
    this.getContract();
    this.getVariables();
  },
  methods: {
    getVariables() {
      axios.get('/jobs/variables').then(res => {
        const vars = Object.values(res.data);
        this.variablesArray = vars.map(variable => {
          return { name: variable };
        });
        this.variablesKeys = Object.keys(res.data);
      });
    },
    /* TOGGLES */
    toggleSidebar() {
      this.opened = !this.opened;
    },
    showSidebar() {
      this.sidenav = !this.sidenav;
    },
    /* END OF TOGGLES */

    /* START OF DRAG AND DROP METHODS */
    dragOver(ev) {
      ev.preventDefault();
      this.dragging = true;
    },
    dragLeave(ev) {
      this.dragging = false;
      ev.target.classList.remove('dragged');
    },
    dragStart(columns, ev) {
      ev.dataTransfer.effectAllowed = 'move';
      ev.dataTransfer.setData('text/html', this.innerHTML);
      this.draggingElement = columns;
    },
    dragDrop(id, ev) {
      if (!this.drag) {
        this.addContainerToSection(id);
      }
      this.dragging = false;
      ev.target.classList.remove('dragged');
    },
    dragEnd() {
      this.drag = false;
      for (let i = 0; i < this.sections.length; i += 1) {
        this.sections[i].order = i + 1;
      }
    },
    /* END OF DRAG AND DROP METHODS */

    /* CONTRACT CRUD */
    getContract() {
      axios.get(`contracts/${this.$route.params.id}`).then(res => {
        this.sections = _.orderBy(res.data.data.sections, ['order'], ['asc']);
        this.sections.forEach(section => {
          section.uid = section.id;
          section.components.forEach(column => {
            column.uid = column.id;
            delete column.fields;
          });
        });
        this.contractActive = res.data.data.active;
        this.contractName = res.data.data.name;
        this.contractUpdated = res.data.data.updated_at;
        this.companyIds = res.data.data.company_ids;
        this.contractActive = res.data.data.active;
        this.contractType = res.data.data.type;
      });
    },
    saveContract(name, id, active) {
      axios
        .put(`contracts/${this.$route.params.id}`, {
          name,
          active,
          company_ids: id,
          sections: this.sections,
          type_id: this.contractType.id,
        })
        .then(() => {
          toastr.success('Successfully edited contract');
          this.getContract();
        })
        .catch(err => {
          if (err.response.data.error.html) {
            toastr.error(err.response.data.error.html[0]);
          }
          this.errors.record(err.response.data.error);
        });
    },
    /* END OF CONTRACT CRUD */

    /* SECTION AND CONTAINER CRUD / FE */
    storeHtmlToObject(value, sectionId, columnId) {
      this.sections.forEach(section => {
        if (section.uid === sectionId)
          section.components.forEach(column => {
            if (column.uid === columnId) {
              column.html = value;
            }
          });
      });
    },
    createSection() {
      // generate parsed unique id and use it to create new section by pushing data into the object
      const newId = parseInt(_.uniqueId(), 10);
      this.sections.push({
        uid: newId,
        rows: null,
        editor_display: true,
        order: this.sections.length + 1,
        customer_display: 0,
        mover_display: 0,
        components: [],
      });
    },
    deleteContainer(id) {
      this.sections.splice(this.sections.findIndex(i => i.uid === id), 1);
    },
    deleteColumn(sectionId, componentId) {
      this.sections.forEach(section => {
        if (section.id === sectionId) {
          // section.components.splice(section.components.findIndex(i => i.uid === componentId), 1);
          section.components.forEach(column => {
            if (column.uid === componentId) {
              column.class += ' noEditor';
              column.html = '<p></p>';
            }
          });
        }
      });
    },
    addContainerToSection(sectionId) {
      let numOfRows = null;
      switch (this.draggingElement) {
        case 1:
          numOfRows = [
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-12',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
          ];
          break;
        case 2:
          numOfRows = [
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-6',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-6',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
          ];
          break;
        case 3:
          numOfRows = [
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-4',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-4',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-4',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
          ];
          break;
        case 4:
          numOfRows = [
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-8',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-4',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
          ];
          break;
        case 5:
          numOfRows = [
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-4',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
            {
              uid: parseInt(_.uniqueId(), 10),
              class: 'col-md-8',
              html: '',
              customer_display: 0,
              mover_display: 0,
            },
          ];
          break;
        default:
          console.log('switch error');
      }
      this.sections.forEach(section => {
        if (section.uid === sectionId) {
          if (section.components.length > 0) {
            this.$swal({
              title: 'Override entire section',
              text:
                'You are about to add a new container inside the section. It will override everything inside current containers. You will not be able to revert this action. Are you sure you want to continue?',
              type: 'error',
              showCancelButton: true,
              confirmButtonText: 'Yes, override',
              cancelButtonText: 'No, cancel',
              showCloseButton: true,
              showLoaderOnConfirm: true,
            }).then(result => {
              if (result.value) section.components = numOfRows;
            });
          } else {
            section.components = numOfRows;
          }
        }
      });
    },
    /* END OF SECT/CONTAINER CRUD FE METHODS */

    /* PDF METHOD */
    previewPdf(name, id, active) {
      axios
        .post(
          `preview`,
          {
            name,
            company_ids: id,
            sections: this.sections,
            active,
          },
          {
            responseType: 'blob',
            transformResponse: [
              data => {
                const blob = new window.Blob([data], { type: 'application/pdf' });
                return window.URL.createObjectURL(blob);
              },
            ],
          },
        )
        .then(res => {
          this.pdf = res.data;
          window.open(this.pdf);
          window.focus();
        });
    },
    /* END OF PDF METHOD */
  },
};
</script>
<style scoped>
.left-side {
  background: #f1f4f7;
  margin-top: 62px;
  min-height: calc(100vh - 62px);
}
.right-side {
  box-shadow: -6px 1px 6px 0 rgba(237, 237, 237, 0.94);
  overflow: hidden;
  position: fixed;
  top: 0;
  right: -6px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.contract-section {
  color: rgb(21, 77, 233);
  background: white;
  min-height: 120px;
  border: 1px dashed gray;
  padding-bottom: 10px;
}
.new-section {
  height: 50px;
  background: white;
}
.new-section-btn {
  color: rgb(21, 77, 233);
}

.new-section-btn:hover {
  opacity: 0.7;
}
.box {
  border-radius: 3px;
  background: #e8ebef;
}
.box-1,
.box-2,
.box-3 {
  padding: 15px 10px;
}
.box-1 div,
.box-2 div,
.box-3 div {
  background: rgba(41, 98, 255, 0.6);
}
.box-column {
  height: 30px;
}
.dragged {
  background: #f2f9f2;
}
.hidden {
  display: none;
}
.chevron {
  margin: 5px;
}
.delete-section-ico {
  color: rgb(21, 77, 233);
}
.fixed {
  right: -19px !important;
}
.swal2-container .swal2-center .swal2-shown {
  background-color: rgba(0, 0, 0, 0.6);
}
[draggable='true'] {
  -khtml-user-drag: element;
}
/* fix visibility overlap bug */
span.container-fluid.mt-3.flex {
  transform: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractEdit.vue